function getResponseErrorMessage(error) {
  const responseError = error?.response?.data?.error;

  if (typeof responseError === "string") {
    return responseError;
  }

  if (responseError && typeof responseError.message === "string") {
    return responseError.message;
  }

  return null;
}

function isProviderAccessRevokedError(error) {
  return (
    error?.response?.status === 403 &&
    getResponseErrorMessage(error) === "You do not have access to this provider"
  );
}

function isAuthSessionError(error) {
  return error?.response?.status === 401 || isProviderAccessRevokedError(error);
}

export {
  getResponseErrorMessage,
  isProviderAccessRevokedError,
  isAuthSessionError,
};
